import { Grid, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { normalizeDuration } from '../../lib/utils';

type Props = {
    grid?: boolean;
    caption: string;
    defVal?: number;
    min?: number;
    max?: number;
    interval: number;
    onChange: (value: number) => void;
    [key: string]: unknown;
};

// Componente para seleccionar intervalos (en minutos). Empezando por min, hasta max, cada interval
/**
 *
 * string caption - field caption
 * int defVal - selected value
 * int min - minimum minutes available for selection
 * int max - maximum minutos available for selection
 * int interval - length of intervals (in minutes, obviously)
 * Function onChange(minutes) - callback for select
 */
export function SttSelectInterval({
    grid = false,
    caption,
    defVal = 0,
    min = 10,
    max = 23 * 60, // From 00:00 to 23:00
    interval,
    onChange,
    ...rest
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // Un primer elemento falso para seleccionar '0'. TODO: pensarse esto porque no me convence
    const menuItems = [
        <MenuItem key={0} value={0}>
            {t('common.select')}
        </MenuItem>,
    ];

    // Creamos los elementos
    for (let i = min; i <= max; i += interval) {
        menuItems.push(
            <MenuItem key={i} value={i}>
                {/* `${i} ${minutesWord}` */}
                {normalizeDuration(i)}
            </MenuItem>,
        );
    }

    const content = (
        <FormControl variant="outlined" size="small" style={{ width: '100%' }}>
            <InputLabel>{caption}</InputLabel>
            <Select
                value={defVal}
                onChange={(e: any) => onChange(e.target.value as number)}
                label={caption}
            >
                {menuItems}
            </Select>
        </FormControl>
    );

    return grid ? <Grid {...rest}>{content}</Grid> : content;
}
